import {ZIDX, ZIDXPage} from "../../standalone/standaloneLibrary.js";

export class ZIDXAccountCrawlSiteSearch implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountCrawlSiteSearchContainer";
    }
    render(){
        let self = this;
        let root = this.zidx.peakidxShadowRoot;
        let searchInput = root.getElementById("crawlSiteSearchQuery") as HTMLInputElement;
        let searchButton = root.getElementById("crawlSiteSearchButton") as HTMLInputElement;
        let siteIdInput = root.getElementById("crawlSiteSearchSiteId") as HTMLInputElement;
        let statusEl = root.getElementById("crawlSiteSearchStatus") as HTMLElement;
        let resultsEl = root.getElementById("crawlSiteSearchResults") as HTMLElement;
        if(!searchInput || !searchButton || !siteIdInput) return;

        let runSearch = function(){
            let query = searchInput.value.trim();
            if(!query){
                statusEl.textContent = "Please enter a search query.";
                return;
            }
            let siteId = siteIdInput.value;
            statusEl.textContent = "Searching...";
            resultsEl.innerHTML = "";
            searchButton.disabled = true;

            self.zidx.ajaxRequest({
                id: "crawlSiteVectorSearch",
                method: "post",
                postObj: {
                    crawl_site_id: siteId,
                    query: query,
                    max_results: "20"
                },
                url: "/account/crawl-sites/search/query",
                callback: function(r:string){
                    searchButton.disabled = false;
                    try {
                        let js:any = JSON.parse(r);
                        if(!js.success){
                            statusEl.textContent = "Error: " + (js.errorMessage || "Search failed.");
                            return;
                        }
                        let results = js.results || [];
                        let count = js.count || 0;
                        let durationMs = js.durationMs || 0;
                        statusEl.textContent = count + " result" + (count !== 1 ? "s" : "") + " in " + durationMs + "ms";
                        if(count === 0){
                            resultsEl.innerHTML = "<p>No results found.</p>";
                            return;
                        }
                        self.renderResults(resultsEl, results);
                    } catch(e){
                        statusEl.textContent = "Error parsing response.";
                    }
                },
                errorCallback: function(){
                    searchButton.disabled = false;
                    statusEl.textContent = "Network error. Please try again.";
                }
            });
        };

        searchButton.addEventListener("click", runSearch);
        searchInput.addEventListener("keydown", function(e:KeyboardEvent){
            if(e.key === "Enter"){
                runSearch();
            }
        });
    }

    renderResults(container:HTMLElement, results:any[]){
        let html = '<table style="width:100%;border-collapse:collapse;margin-top:8px;">';
        html += '<tr style="">';
        html += '<th style="padding:6px 8px;text-align:left;border:1px solid #ddd;">#</th>';
        html += '<th style="padding:6px 8px;text-align:left;border:1px solid #ddd;">Page</th>';
        html += '<th style="padding:6px 8px;text-align:left;border:1px solid #ddd;">Section</th>';
        html += '<th style="padding:6px 8px;text-align:left;border:1px solid #ddd;">Text</th>';
        html += '<th style="padding:6px 8px;text-align:left;border:1px solid #ddd;">Tokens</th>';
        html += '</tr>';
        for(let i = 0; i < results.length; i++){
            let r = results[i];
            let bg = i % 2 === 0 ? "rgba(128,128,128,0.15)" : "rgba(128,128,128,0.0)";
            let text = this.escapeHtml(r.text || "");
            if(text.length > 300){
                text = text.substring(0, 300) + "...";
            }
            let pageTitle = this.escapeHtml(r.pageTitle || "Untitled");
            let pageUrl = this.escapeHtml(r.pageUrl || "");
            let heading = this.escapeHtml(r.headingContext || "");
            html += '<tr style="background:' + bg + ';">';
            html += '<td style="padding:6px 8px;border:1px solid #ddd;vertical-align:top;">' + (i + 1) + '</td>';
            html += '<td style="padding:6px 8px;border:1px solid #ddd;vertical-align:top;">';
            if(pageUrl){
                html += '<a href="' + pageUrl + '" target="_blank">' + pageTitle + '</a>';
            } else {
                html += pageTitle;
            }
            html += '</td>';
            html += '<td style="padding:6px 8px;border:1px solid #ddd;vertical-align:top;">' + heading + '</td>';
            html += '<td style="padding:6px 8px;border:1px solid #ddd;vertical-align:top;font-size:13px;">' + text + '</td>';
            html += '<td style="padding:6px 8px;border:1px solid #ddd;vertical-align:top;">' + (r.tokenCount || 0) + '</td>';
            html += '</tr>';
        }
        html += '</table>';
        container.innerHTML = html;
    }

    escapeHtml(str:string):string {
        return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }
}
